export const mugImprintID =  "4d4a4d9b-4308-46ff-9492-149b82669dff";
// NOTE: why buy ID is also stored in locale key: infopages > employment
export const whyBuyID = "3e8cba4a-f0f5-4d34-819e-c221131719bf";
export const beCertainID = "a1488d91-3d14-4ce8-9543-8439211b2a72";